var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5364 6.96932V12.6163C18.5364 15.8113 15.9644 18.4113 12.8034 18.4113H7.21738C4.05638 18.4113 1.48438 15.8113 1.48438 12.6163V6.96932C1.48437 3.77432 4.05638 1.17432 7.21738 1.17432H12.8034C15.9644 1.17432 18.5364 3.77432 18.5364 6.96932ZM15.6204 5.08632C15.6214 4.83188 15.5215 4.58743 15.3424 4.40667C15.1633 4.22592 14.9198 4.12364 14.6654 4.12232C14.4107 4.12338 14.1668 4.2255 13.9874 4.40626C13.8079 4.58702 13.7076 4.83162 13.7084 5.08632C13.7084 5.61932 14.1384 6.05032 14.6654 6.05032C14.9198 6.04899 15.1633 5.94672 15.3424 5.76596C15.5215 5.5852 15.6214 5.34075 15.6204 5.08632ZM10.0104 6.17632C8.03837 6.17632 6.43337 7.79932 6.43337 9.79232C6.43337 11.7863 8.03837 13.4073 10.0104 13.4073C11.9824 13.4073 13.5874 11.7873 13.5874 9.79232C13.5874 7.79932 11.9824 6.17632 10.0104 6.17632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e683dc364191d905236e2d7e67050d62.svg";
export { ForwardRef as ReactComponent };